__turbopack_context__.v({
  "className": "space_grotesk_30b7c09c-module__4Xo8tG__className",
});
